import React, { createContext } from 'react';
import styled from 'styled-components';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { closeModal } from './Modal';

const ContainerDiv = styled.div`
  .transition-enter {
    opacity: 0.01;
  }
  .transition-enter-active {
    opacity: 1;
    transition: all 300ms ease-in;
  }
  .transition-exit {
    opacity: 1;
  }
  .transition-exit-active {
    opacity: 0.01;
    transition: all 300ms ease-in;
  }
`;

let portalContainer;
export default class PortalContainer extends React.Component {
  state = {
    children: [],
    // el: null,
  };

  constructor() {
    super();
    // this.setRef = (el) => this.setState({ el });
    portalContainer = this;
  }

  render() {
    const { children } = this.state;
    return (
      <>
        {this.props.children}
        <div id='x'>
        {children.map((c, i) => <React.Fragment key={i}>{c.component}</React.Fragment>)}
        </div>
      </>
    );
  }
}

export const PortalContext = createContext();

export function addPortal(child) {
  portalContainer.setState({
    children: [...portalContainer.state.children, child],
  });
}

export function removePortal(child) {
  portalContainer.setState({
    children: portalContainer.state.children.filter((c) => c !== child),
  });
}

export function removePortalType(type) {
  const { children } = portalContainer.state;
  for (let i = children.length - 1; i >= 0; i--) {
    debugger
    if (children[i].type === type) {
      removePortal(children[i]);
      break;
    }
  }
}

export function removeAll() {
  portalContainer.setState({
    children: [],
  });
}

